import { Component, Input, OnInit } from '@angular/core';
import { PostDO } from '../../common/data-objects/PostDO';

@Component({
  selector: 'app-activity-thumbnail',
  templateUrl: './activity-thumbnail.component.html',
  styleUrls: ['./activity-thumbnail.component.scss']
})
export class ActivityThumbnailComponent implements OnInit {
  @Input() postData: PostDO;

  constructor() { }

  ngOnInit() {
  }

  get postLink(): string[] {
    return [this.postData.slug];
  }

  get postImage(): string {
    return `url(${this.postData.featuredImageSizes.mediumLarge ? this.postData.featuredImageSizes.mediumLarge : 'assets/logo.svg'})`;
  }
}
